<template>
  <div :class="{ dropdown: true, 'is-open': isOpen }" v-on-clickaway="onClickaway">
    <div :class="{'empty-label': hasLabel}" class="dropdown-opener" @click.stop="toggle()">
      <span>{{label}}</span>
      <span v-if="icon === 'arrow'">
        <i v-if="isOpen" class="fa fa-angle-up" :style="style"></i>
        <i v-else class="fa fa-angle-down" :style="style"></i>
      </span>
      <span v-else>
        <i class="fa" :class="icon" :style="style"></i>
      </span>
    </div>
    <div class="overflow-fix z-30" :class="{'relative': inEditor}">
      <div
        class="dropdown-content"
        :style="listStyle"
        :class="{'hasLinks': hasLinks}"
        v-if="isOpen"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],

  props: {
    label: { type: String, required: true },
    openByDefault: { type: Boolean, default: false },
    icon: { type: String, default: "arrow" },
    color: { type: String, default: "#494949" },
    hasLinks: { type: Boolean, default: false },
    listStyle: { type: String, default: "" }
  },

  data() {
    return {
      wasOpened: false,
      wasClosed: false,
      openId: null,
      inEditor: null
    };
  },

  mounted() {
    this.$root.$on("checkSiblings", data => {
      this.openId = data;
    });

    this.$nextTick(() => {
      this.inEditor = !!document.querySelector(".video-editor");
    });
  },

  computed: {
    isOpen() {
      return (
        (this.wasOpened || (this.openByDefault && !this.wasClosed)) &&
        this.openId == this._uid
      );
    },
    hasLabel() {
      return this.label === "";
    },
    style() {
      return "color: " + this.color + ";";
    }
  },

  methods: {
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    open() {
      this.$root.$emit("checkSiblings", this._uid);
      this.wasOpened = true;
      this.wasClosed = false;
    },

    close() {
      this.wasOpened = false;
      this.wasClosed = true;
    },

    onClickaway() {
      if (this.isOpen && this.$media("md")) {
        this.close();
      }
    }
  },

  watch: {
    isOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("change", newValue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "styles/_media.scss";

.dropdown-content {
  display: none;
}

.is-open .dropdown-content {
  display: block;
}

.dropdown-opener i {
  margin-left: 4px;
  font-weight: 400;
}

.overflow-fix {
  position: absolute;
  width: 30px;
}

@include desktop() {
  .dropdown {
    margin: 0 2px;
    position: initial;
  }

  .dropdown-opener {
    border-radius: 2px;
    border: 1px solid #cccccc;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 18px;
    &.empty-label {
      border: none;
      padding: 4px 14px;
      display: inline-block;
      i {
        margin-left: 0;
      }
    }

    // &:hover {
    //   background: #f1f1f1;
    // }
  }

  .dropdown-content {
    border-radius: 2px;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 20;

    background: white;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
    padding: 8px 16px;

    max-height: 400px;
    overflow-y: auto;
    &.hasLinks {
      padding: 0;
    }
  }

  .is-open .dropdown-opener {
    // background: #f1f1f1;
  }
}

@include mobile() {
  .dropdown-opener {
    font-size: 18px;
    text-align: left;
    background: #dcdcdc;
    padding: 12px;
  }

  .dropdown-content {
    padding: 12px;
    background: #f1f1f1;
  }
}
</style>